import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ApiGo from '../../../actions/ApiGo';
import ConfigHandler from '../../../actions/ConfigHandler';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../stores/reducer_add';

const ServerSetting = (props) => {
  const { t } = useTranslation();
  const Debug_LEVEL = ["Debug", "Warning", "Info", "Error", "Critical", "Panic"];
  const [timer, setTimer] = useState(5);
  const [stopProccess, setStopProccess] = useState(false);
  const [shutdownORrestart, setShutdownORrestart] = useState("");
  const [level, setLevel] = useState("");
  const dispatch = useDispatch();

  function toggoleStop() { setStopProccess(true) }

  useEffect(() => {
    let confirm_info;
    let timeoutId;

    if (timer === 5 && !stopProccess && shutdownORrestart === "restart") {
      confirm_info = window.confirm(t("ADMIN.BACKUP.CONFIRM_RESTART", "確定要重啟伺服器? 伺服器重啟需要等待數分鐘。"));
    } else if (timer === 5 && !stopProccess && shutdownORrestart === "shutdown") {
      confirm_info = window.confirm(t("ADMIN.BACKUP.CONFIRM_SHUTDOWN", "確定要關閉伺服器?"));
    }

    if (timer === 5 && !confirm_info && !stopProccess && shutdownORrestart !== "") {
      setShutdownORrestart("");
      setStopProccess(false);
      return;
    }

    if (!stopProccess && shutdownORrestart !== "") {
      timeoutId = setTimeout(() => {
        let _t = timer;
        setTimer(countdown(_t));
      }, 1200);
    } else {
      setShutdownORrestart("");
      setStopProccess(false);
      setTimer(5);
      return;
    }

    if (timer === 0) {
      if (shutdownORrestart === "restart") { restartSystem() }
      else if (shutdownORrestart === "shutdown") { shutdownSystem() }
      setStopProccess(true);
      return;
    }

    function countdown(_t) {
      _t -= 1;
      if (shutdownORrestart === "") { return 5 }
      if (stopProccess) { return 5 }
      return _t;
    }

    return (() => { clearTimeout(timeoutId) })
  }, [stopProccess, shutdownORrestart, timer]);

  function restartSystem() {
    ApiGo.get_system_restart()
      .then(res => { console.log(res); })
      .catch(err => { console.log(err); })
  }
  function shutdownSystem() {
    ApiGo.get_system_shutdown()
      .then(res => { console.log(res); })
      .catch(err => { console.log(err); })
  }
  function putDebugLevel(_level) {
    ApiGo.putUpdate_bug_level(_level)
      .then(res => { console.log(res); alert(t("ADMIN.BACKUP.REBOOT_WARNING")) })
      .catch(err => { console.log(err); })
  }
  function restartUart() {
    ApiGo.set_uart_test_restart()
      .then(res => {
        dispatch(ADD_RESPONSE({ status: 200, statusText: "", type: "alert_reply" }))
        dispatch(ADD_RESPONSE_JSON({ detail: [{ loc: ["body", ""] }, { loc: ["body", ""] }] }))
      })
      .catch((err) => {
        dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "alert_reply" }))
        return err.response
      })
      .then(res => { dispatch(ADD_RESPONSE_JSON(res)) })
  }

  useEffect(() => {
    ApiGo.get_bug_level()
      .then(res => {
        if (res === 'Warn') { setLevel("Warning") }
        else { setLevel(res) }
      })
      .catch(err => { console.log(err); })
  }, [])

  return (
    <div className='w-100 h-100'>
      <div className="fx-d-c font-m bgC-white w-40 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs">
        <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.BACKUP.DEBUG_LEVEL")}</div>
        <div className='font-m margl-xs '>{t("ADMIN.BACKUP.DEBUG_LEVEL_WARNING")}</div>
        <div className='fx-d-r margl-xs font-ml w-70 pad-15 t fx-cspbt'>
          <select className="wid-admin-s font-m bgC-grey" value={level} onChange={e => { setLevel(e.target.value) }}>
            {Debug_LEVEL.map(_level => {
              // 顯示用翻譯，option value 保留原始英文
              return <option key={_level} value={_level}>{t(`ADMIN.BACKUP.DEBUG_LEVELS.${_level}`, _level)}</option>
            })}
          </select>
          <div className='br-10 bgC-light fx-ccc pad-15 l r shadow-xs' onClick={() => { putDebugLevel(level) }}>{t("GLOBAL.CONFIRM")}</div>
        </div>
      </div>

      {
        ConfigHandler.isShowAIDC() ?
          <div className="fx-d-c font-m bgC-white w-40 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs">
            <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.BACKUP.AIDC_TITLE")}</div>
            <div className='margl-xs w-90 h-100 margt-xxs'>
              {t("ADMIN.BACKUP.AIDC_DESC")}
            </div>
            <div className='fx-d-r margl-xs font-ml w-70 pad-15 t fx-cspbt'>
              <div className='br-10 bgC-light fx-ccc pad-15 l r shadow-xs' onClick={restartUart}>{t("ADMIN.BACKUP.AIDC_RESTART_BUTTON")}</div>
            </div>
          </div>
          :
          null
      }

      <div className="fx-d-c font-m bgC-white w-40 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs">
        <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.BACKUP.SYSTEM_POWER")}</div>

        {(shutdownORrestart !== "") ?
          <div className='font-m margl-xs '>
            {t("ADMIN.BACKUP.WILL_IN_SECONDS", { timer })}
            {` `}
            {shutdownORrestart === "restart" ? t("ADMIN.BACKUP.REBOOT") : t("ADMIN.BACKUP.POWEROFF")}
          </div>
          :
          <div className='font-m margl-xs '>{t("ADMIN.BACKUP.REBOOT_POWEROFF")}</div>
        }

        <div className='fx-d-r margl-xs font-ml w-70 pad-15 t fx-fsc'>
          {(shutdownORrestart !== "") ?
            <div className='br-10 bgC-alert-E fx-ccc wid-admin-8s pad-5 t b shadow-xs'
              onClick={toggoleStop}>{t("GLOBAL.CANCEL")}</div>
            : <>
              <div className='br-10 bgC-green fx-ccc wid-admin-8s pad-5 t b shadow-xs'
                onClick={() => { setShutdownORrestart("restart") }}>{t("ADMIN.BACKUP.REBOOT")}</div>
              <div className='br-10 bgC-alert-EE fx-ccc wid-admin-8s pad-5 t b margl-s shadow-xs'
                onClick={() => { setShutdownORrestart("shutdown") }}>{t("ADMIN.BACKUP.POWEROFF")}</div>
            </>}
        </div>
      </div>
    </div>
  );

}

export default ServerSetting;